import {httpDelete, httpGet} from "../libs/http";

export const adminLoadDashboard = (onSuccess = null, onFailure = null) => dispatch => {
    httpGet('/admin/dashboard/', (res) => onSuccess(res), (err) => onFailure(err));
}

export const deleteFailedSSLCertificate = (guid, onSuccess = null, onFailure = null) => dispatch => {
    httpDelete('/admin/system/failed-ssl-certificate/' + guid + '/', (res) => onSuccess(res), (err) => onFailure(err));
}